module.exports = __webpack_public_path__ + "assets/img/tx20gs.61a2c63d.jpg";